import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mainNewsItemComponent from './mainNewsItem.component';

let mainNewsItemModule = angular.module('mainNewsItem', [
  uiRouter
])
  .config(($stateProvider) => {
    'ngInject';
    $stateProvider
      .state('news.item', {
        url: '/:officeId/:newsId',
        component: 'mainNewsItem',
        resolve: {
          selectedNews: (NewsService, $stateParams) => NewsService.fullNews($stateParams.newsId, $stateParams.officeId),
          $title: (selectedNews) => `News - ${selectedNews.title}`
        }
      })
  })
  .component('mainNewsItem', mainNewsItemComponent)
  .name;

export default mainNewsItemModule;



// WEBPACK FOOTER //
// ./client/app/components/news/mainNewsItem/mainNewsItem.js